module.exports = __webpack_public_path__ + "static/media/25-15.ac6fbfd9.mp3";